import type { ProofPoint } from '@portfolio/shared';
import type { JSX } from 'react';

import { cn } from '@/lib/cn';

interface ProofPointListProps {
  items: readonly ProofPoint[];
  className?: string;
}

/**
 * A description list, because each item genuinely is a term and its
 * explanation. No invented figures: every value comes from the CV.
 */
export function ProofPointList({ items, className }: ProofPointListProps): JSX.Element {
  return (
    <dl
      className={cn(
        'grid gap-px overflow-hidden rounded-lg border border-line bg-line sm:grid-cols-2 lg:grid-cols-4',
        className,
      )}
    >
      {items.map((item) => (
        <div key={item.id} className="bg-surface p-5">
          <dt className="text-sm font-semibold text-text">{item.value}</dt>
          <dd className="mt-1 text-sm text-muted">{item.label}</dd>
        </div>
      ))}
    </dl>
  );
}
